import script from "./ContactFields.vue?vue&type=script&lang=ts&setup=true"
export * from "./ContactFields.vue?vue&type=script&lang=ts&setup=true"

import "./ContactFields.vue?vue&type=style&index=0&id=21d333f8&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-21d333f8"]])

export default __exports__